module.exports = __webpack_public_path__ + "static/img/main-visual-s.61ffacd.png";